// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"45790b88","572":"b531627b","918":"b531627b","989":"f74bd4f3","993":"b531627b"}[chunkId] + ".chunk.css";
};